// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ColumnFilterDialog_wrapper__OaHAd","box":"ColumnFilterDialog_box__Pttp1","active":"ColumnFilterDialog_active__JgiXI","inactive":"ColumnFilterDialog_inactive__14gLr"};